var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "search--template page-template page page-transition bg-beige",
    },
    [
      _c("div", { staticClass: "relative container-fluid z-content" }, [
        _c(
          "section",
          {
            staticClass:
              "relative center w-100 pt2 pt4-ns pb3 pb5-ns z-content",
          },
          [
            _c("div", { staticClass: "relative center" }, [
              _c(
                "div",
                { staticClass: "relative center mv4 pv4 ph4 bg-navy" },
                [
                  _c(
                    "form",
                    {
                      staticClass: "relative search-form",
                      attrs: { onsubmit: "return false;" },
                    },
                    [
                      _c("div", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.query,
                              expression: "query",
                            },
                          ],
                          staticClass:
                            "dib w-100 search-input-css bb--is-beige-1px f4 is-tablet-regular is-beige z-1",
                          attrs: {
                            type: "text",
                            id: "search",
                            name: "search",
                            required: "",
                            placeholder: " ",
                          },
                          domProps: { value: _vm.query },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.query = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "f4 search label is-beige",
                            attrs: { for: "search" },
                          },
                          [_vm._v("[search term here]")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "db absolute right-0 nt4",
                            on: { click: function ($event) {} },
                          },
                          [
                            _c("img", {
                              staticClass: "db relative w2",
                              attrs: {
                                src: "/assets/images/svg-icons/search-icon-beige.svg",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "f4 f4-ns tc is-black z--1",
                            attrs: { for: "email" },
                          },
                          [_vm._v("eg. Lineup, tickets")]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.query == null || _vm.query === "" || _vm.query === " "
                ? _c("div", {}, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "f3 mv3 vh-50 tl lh-title is-tablet-regular is-black",
                      },
                      [
                        _vm._v(
                          "\n            Please enter something to search such as "
                        ),
                        _c(
                          "router-link",
                          {
                            staticClass: "is-orange link pointer",
                            attrs: {
                              to: "/search/?search=tickets",
                              title: "tickets",
                            },
                          },
                          [_vm._v("tickets")]
                        ),
                        _vm._v(" or "),
                        _c(
                          "router-link",
                          {
                            staticClass: "is-orange link pointer",
                            attrs: {
                              to: "/search/?search=news",
                              title: "news",
                            },
                          },
                          [_vm._v("news")]
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("div", { staticClass: "w-100" }, [
                    _c("div", { staticClass: "relative" }, [
                      _vm.queryResults.length == 0
                        ? _c("div", { staticClass: "relative" }, [
                            _c("div", { staticClass: "f3 mv3 tl" }, [
                              _c(
                                "p",
                                [
                                  _vm._v(
                                    "\n                  Please try a different search, such as "
                                  ),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "is-orange link pointer",
                                      attrs: {
                                        to: "/search/?search=lineup",
                                        title: "lineup",
                                      },
                                    },
                                    [_vm._v("lineup")]
                                  ),
                                  _vm._v(" or "),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "is-orange link pointer",
                                      attrs: {
                                        to: "/search/?search=tickets",
                                        title: "tickets",
                                      },
                                    },
                                    [_vm._v("tickets")]
                                  ),
                                  _vm._v(".\n                "),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "relative pt0 pt3-ns" }, [
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(
                                _vm.queryResults,
                                function (result, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "search-result-" + index,
                                      staticClass:
                                        "col-xs-12 col-sm-4 mv3 mv4-ns",
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db relative no-underline hover-text-h is-black link pointer",
                                          attrs: {
                                            to: result.url,
                                            title: result.title,
                                          },
                                        },
                                        [
                                          _c(
                                            "h3",
                                            {
                                              staticClass:
                                                "db f2 mv3 tl no-underline ttn is-tablet-bold is-navy",
                                            },
                                            [_vm._v(_vm._s(result.title))]
                                          ),
                                          _vm._v(" "),
                                          result.excerpt
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-tablet-regular is-black mv2 lh-copy",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("truncate")(
                                                          result.excerpt,
                                                          140,
                                                          "..."
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "db mv3 no-underline pointer link",
                                              attrs: { to: result.url },
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "f4 is-tablet-regular ttu is-black text",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Read More\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                    ]),
                  ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }